<template>
  <div class="row book w-100">
    <!-- <canvas id="widget-1" style="width: 100%"></canvas> -->
    <iframe src="/actividad1.html" frameborder="0" width="100%" height="100%" style="border: none"></iframe>
  </div>
</template>
<script>
import NProgress from 'nprogress';

export default {
  name: 'activity1',
  async created() {
    NProgress.done();
  },
  computed: {
    missionId () {
      return this.$route.params.missionId;
    }
  },
  methods: {
    logout() {
      Auth.logout();
    },
    goToMission() {
      this.$router.push(`/mission/${this.missionId}`);
    }
  },
}
</script>
<style lang="scss">
.book {
  min-height: 80vh;
}
</style>